import {Form, formsStore} from '../../../../stores/Form';

export const handleFocusAction = async (
    currentForm: Form,
    columnIndex: number,
    newRowIndex?: number
) => {
    return formsStore.currentScreen?.onFieldFocusChange(
        {
            newCellIndex: columnIndex,
            newRowIndex: typeof newRowIndex === 'number' ? newRowIndex : currentForm.currentRow,
            level: currentForm.level
        },
        async () => currentForm.setCurrentColumnIdByIndex(columnIndex)
    );
};
